import { render, staticRenderFns } from "./CreatePlusJumbotron.vue?vue&type=template&id=65d71eb2&scoped=true&"
import script from "./CreatePlusJumbotron.vue?vue&type=script&lang=js&"
export * from "./CreatePlusJumbotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d71eb2",
  null
  
)

export default component.exports